import { StyleSheet, Platform } from 'react-native';
import { COLORS } from '../constants/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9FAFB',
    padding: 0,
    margin: 0,
  },
  centerContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F9FAFB',
    padding: 20,
    margin: 0,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 20,
    paddingTop: Platform.OS === 'ios' ? 50 : 20,
    width: '100%',
  },
  headerDesktop: {
    paddingTop: 20,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    backgroundColor: '#FFFFFF',
  },
  backIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  backIconText: {
    fontSize: 36,
    color: COLORS.primary,
    fontWeight: '300',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: [{ translateX: -8 }, { translateY: -28 }],
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: COLORS.text,
  },
  headerSpacer: {
    width: 40,
  },
  favouriteButton: {
    width: 40,
    height: 40,
  },
  shareButton: {
    minWidth: 72,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 14,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  shareButtonDisabled: {
    opacity: 0.6,
  },
  shareButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: COLORS.primary,
  },
  scrollView: {
    flex: 1,
    padding: 0,
    margin: 0,
  },
  scrollContent: {
    paddingHorizontal: 15,
    paddingTop: 16,
    paddingBottom: 20,
  },
  desktopContainer: {
    width: '100%',
    paddingHorizontal: 0,
  },
  section: {
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    padding: 20,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 2,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 16,
    fontFamily: 'Montserrat_600SemiBold',
  },
  titleSeparator: {
    height: 1,
    backgroundColor: '#E5E7EB',
    marginTop: -8,
    marginBottom: 16,
  },
  earlyRedemptionItem: {
    marginBottom: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  earlyRedemptionRow: {
    flexDirection: 'row',
    gap: 12,
  },
  earlyRedemptionField: {
    flex: 1,
  },
  earlyRedemptionLabel: {
    fontSize: 12,
    color: '#757575',
    marginBottom: 4,
  },
  earlyRedemptionValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#212121',
  },
  loadingText: {
    marginTop: 12,
    fontSize: 14,
    color: '#757575',
  },
  errorText: {
    fontSize: 16,
    color: '#F44336',
    textAlign: 'center',
    marginBottom: 20,
  },
  errorButton: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: '#2196F3',
    borderRadius: 4,
  },
  errorButtonText: {
    fontSize: 16,
    color: '#FFFFFF',
    fontWeight: '500',
  },
  tabletRow: {
    flexDirection: 'row',
    gap: 16,
    marginBottom: 16,
  },
  tabletColumn: {
    flex: 1,
  },
  desktopRow: {
    flexDirection: 'row',
    gap: 20,
    marginBottom: 16,
  },
  desktopHalfColumn: {
    flex: 1,
  },
  performanceWithUnderlyings: {
    flexDirection: 'row',
    gap: 20,
    overflow: 'hidden',
  },
  performanceChartSection: {
    flex: 2,
    overflow: 'hidden',
    minWidth: 0,
  },
  underlyingsSection: {
    flex: 1,
    minWidth: 280,
  },
});
